import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newSlider/lakeside-3.jpg")